export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'An alert status with the same name already exists in this establishment'
    }
  }
}
